module.exports = __webpack_public_path__ + "static/media/surfing_black_24dp.d3257a3c.svg";